import React from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { PageHeader } from '../../components/ui';

interface Props {
  title: string;
  subtitle?: string;
  description?: string;
}

const EngineerComingSoon: React.FC<Props> = ({ title, subtitle, description }) => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-6 space-y-4">
      <PageHeader title={title} subtitle={subtitle} />
      <div className="bg-white border border-slate-200 rounded-xl p-10 text-center">
        <WrenchScrewdriverIcon className="w-10 h-10 text-slate-400 mx-auto" />
        <div className="mt-3 text-sm font-semibold text-slate-700">Coming soon</div>
        <div className="text-xs text-slate-500 mt-1 max-w-md mx-auto">
          {description ||
            'This area is being built next. Your feedback on what you need here would help us prioritise.'}
        </div>
      </div>
    </div>
  );
};

export default EngineerComingSoon;
